module.exports = __webpack_public_path__ + "static/img/zgdz.fe8e1b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zgdz.png
// module id = iIPU
// module chunks = 0